import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

// RTK Query client for the in-house "Update Rep Location" Action form
// (the Fillout replacement — thread 366). It talks to three endpoints on the
// BFF: the two read-only Phase-1 endpoints (/rep-location/portal/options and
// /rep-location/portal/search) and, since Phase 4 (go-live), the one-shot write
// (/rep-location/portal/save) wired to the Submit button.
//
// All three endpoints are gated server-side to the "Update Rep Location" TABC
// positions (President + VP of Sales today); a non-allowed user gets a 403 here
// and the dialog shows the access message instead of the form.
export const repLocationApi = createApi({
  reducerPath: "repLocationApi",
  // Options rarely change mid-session; cache them a few minutes so reopening the
  // dialog doesn't refetch the whole option set every time.
  keepUnusedDataFor: 300,
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Live dropdown options for every control, mirrored from Airtable.
    getRepLocationOptions: builder.query({
      query: () => ({ url: "/rep-location/portal/options", method: "GET" }),
    }),
    // Rep lookup by name (excludes negative-status reps); returns each match's
    // current values so the form can prefill them.
    searchRepLocation: builder.query({
      query: (q) => ({
        url: `/rep-location/portal/search?q=${encodeURIComponent(q ?? "")}`,
        method: "GET",
      }),
    }),
    // One-shot save (Phase 4 go-live). Body: { employeeRecId, repSummerRecId,
    // values } — `values` carries the form fields keyed exactly as the BFF's
    // FORM_FIELDS expects (payScale/location/fieldRoutesLocations/team/drugTest/
    // pestroutesId). Position is intentionally absent — it moved to the Change
    // Employee Position engine. The BFF writes the Employee + Rep Summer fields
    // and ticks "update field routes accounts", which the existing
    // pestroute-accounts-location-sync cron acts on within ~7 minutes.
    saveRepLocation: builder.mutation({
      query: (body) => ({
        url: "/rep-location/portal/save",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetRepLocationOptionsQuery,
  useLazySearchRepLocationQuery,
  useSaveRepLocationMutation,
} = repLocationApi;
